/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { FormApi } from 'final-form';
import Input, { AmountInput, Select, SelectItem } from 'ui/Input';
import { onlyNCharacters, onlyNumbers } from 'utils/formatters';
import { IWalletState, IFormValues, FindBenNameType,
   IHandleFieldsChange, IMobileMoneyActions } from './ManualEntry.model';

type FormType = FormApi<IFormValues, Partial<IFormValues>>;

const styles = {
  maxWidth: '190px',
};
const renderSourceAccountField = (accounts: IWalletState['accounts'], submitting: boolean) => (
  <Select name="sourceAccount" label="Source Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

// eslint-disable-next-line operator-linebreak
const onSelectNetwork =
  (form: FormType) =>
  ({ target }) => {
    const { value: selectedNetwork, name: networkFieldName } = target as HTMLInputElement;
    form.mutators.changeFieldValue(networkFieldName, selectedNetwork);
  };

export const renderNetworkField = (
  name: string,
  networks: IWalletState['networks'],
  isLookingUp?: IWalletState['isLookingUp'],
  form?: FormType,
) => (
  <Select
    name={`${name}.netWork`}
    label="Network"
    disabled={isLookingUp}
    SelectProps={
      form
        ? {
            onChange: onSelectNetwork(form),
          }
        : undefined
    }
  >
    {networks.map((network) => (
      <SelectItem value={network.code} key={network.name}>
        {network.name}
      </SelectItem>
    ))}
  </Select>
);

export const renderAmountField = (name: string, values: IFormValues, index: number, actions: IMobileMoneyActions) => {
    const handleCharge = () => {
      const { handleElevyResponse } = actions;
      const currentBeneficiary = values?.transferData?.[index];
      if (values) {
        if (currentBeneficiary?.beneficiaryWalletNumber) {
          handleElevyResponse(index);
        }
      }
    };
  return <AmountInput name={`${name}.amount`} label="Amount" onBlur={handleCharge} />;
};

export const renderDescriptionField = (name: string) => (
  <Input
    name={`${name}.description`}
    label="Description"
    fieldProps={{
  parse: onlyNCharacters(25),
}}
  />
);

export const renderBeneficiaryNameField = (name: string, submitting: boolean) => (
  <Input name={`${name}.beneficiaryName`} label="Beneficiary Name" disabled={submitting} />
);

export const renderBenWalletNumberField = (values: IFormValues,
   index: number, name: string, actions: IMobileMoneyActions) => {
    const { findBeneficiaryName } = actions;
    const handleBlur = () => {
      const currentBeneficiary = values?.transferData?.[index];
      if (values) {
        if (currentBeneficiary?.beneficiaryWalletNumber && currentBeneficiary?.netWork) {
          findBeneficiaryName(index);
        }
      }
    };

  return (
    <>
      <Input
        name={`${name}.beneficiaryWalletNumber`}
        label="Wallet Number"
        fieldProps={{
          parse: (value: string) => onlyNCharacters(10)(onlyNumbers(value)),
        }}
        onBlur={handleBlur}
        style={styles}
      />
    </>
  );
};
export const renderWalletNameField = (name: string) => (
  <Input name={`${name}.walletName`} label="Wallet Name" disabled />
);
export const renderWalletFields = (
  name: string,
  values: IFormValues,
  state: IWalletState,
  form: FormType,
  actions: IMobileMoneyActions,
  index: number,
  submitting: boolean,
) => (
  <>
    {renderBeneficiaryNameField(name, submitting)}
    {renderNetworkField(name, state.networks, state.isLookingUp, form)}
    {renderBenWalletNumberField(values, index, name, actions)}
    {renderWalletNameField(name)}
    {renderAmountField(name, values, index, actions)}
    {renderDescriptionField(name)}
  </>
);

export const renderTransferSourceAccount = (accounts: IWalletState['accounts'], submitting: boolean) => (
  <>{renderSourceAccountField(accounts, submitting)}</>
);
